const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const TOKEN_KEY = "km1_coach_session_token";
export const RUNNER_TOKEN_KEY = "km1_runner_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => (t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY));
export const getRunnerToken = () => localStorage.getItem(RUNNER_TOKEN_KEY);
export const setRunnerToken = (t) => (t ? localStorage.setItem(RUNNER_TOKEN_KEY, t) : localStorage.removeItem(RUNNER_TOKEN_KEY));

export const LAST_PROFILE_KEY = "km1_last_profile";
export const getSavedProfile = () => (typeof window !== "undefined" ? localStorage.getItem(LAST_PROFILE_KEY) : null);
export const subscribePath = (plan = "3m") => {
  const pid = getSavedProfile();
  return pid ? `/programme?profile=${pid}&plan=${plan}` : "/profil";
};

async function request(path, opts = {}, auth = false) {
  const headers = { ...(opts.headers || {}) };
  if (!(opts.body instanceof FormData)) headers["Content-Type"] = "application/json";
  if (auth) {
    const t = auth === "runner" ? getRunnerToken() : getToken();
    if (t) headers["Authorization"] = `Bearer ${t}`;
  }
  const res = await fetch(`${API}${path}`, { ...opts, headers });
  const text = await res.text();
  let data = null;
  try { data = text ? JSON.parse(text) : null; } catch { data = text; }
  if (!res.ok) {
    const detail = (data && (data.detail || data.message)) || `Erreur ${res.status}`;
    throw new Error(typeof detail === "string" ? detail : `Erreur ${res.status}`);
  }
  return data;
}

export const api = {
  getConfig: () => request("/config"),
  authSession: (sessionId) => request("/auth/session", { method: "POST", body: JSON.stringify({ session_id: sessionId }) }),
  me: () => request("/auth/me", {}, true),
  logout: () => request("/auth/logout", { method: "POST" }, true),

  searchShoes: (q) => request(`/shoes/search?q=${encodeURIComponent(q)}`),
  createProfile: (payload) => request("/profiles", { method: "POST", body: JSON.stringify(payload) }),
  profileFromBilan: (file, { anonId, firstName, email, consent }) => {
    const fd = new FormData();
    fd.append("file", file);
    fd.append("anon_id", anonId);
    if (firstName) fd.append("first_name", firstName);
    if (email) fd.append("email", email);
    fd.append("consent_marketing", consent ? "true" : "false");
    return request("/profiles/from-bilan", { method: "POST", body: fd });
  },
  completeProfile: (id, payload) => request(`/profiles/${id}/complete`, { method: "POST", body: JSON.stringify(payload) }),
  getProfile: (id) => request(`/profiles/${id}`),
  attachEmail: (id, email, consent, firstName) =>
    request(`/profiles/${id}/email`, { method: "POST", body: JSON.stringify({ email, consent_marketing: consent, first_name: firstName }) }),

  testimonials: () => request("/testimonials"),
  contact: (name, email, message) => request("/contact", { method: "POST", body: JSON.stringify({ name, email, message }) }),

  // Paiement / compte coureur
  checkout: (profileId, plan, email, referralCode) =>
    request("/checkout", { method: "POST", body: JSON.stringify({ profile_id: profileId, plan, email, referral_code: referralCode || undefined }) }),
  checkoutDiscovery: (plan, { email, referralCode, anonId } = {}) =>
    request("/checkout/discovery", { method: "POST", body: JSON.stringify({ plan, email: email || undefined, referral_code: referralCode || undefined, anon_id: anonId || undefined }) }),
  redeem: (profileId, code, email) =>
    request("/redeem", { method: "POST", body: JSON.stringify({ profile_id: profileId, code, email: email || undefined }) }),
  startTrial: (profileId, email) =>
    request("/trial/start", { method: "POST", body: JSON.stringify({ profile_id: profileId, email }) }),
  referralCheck: (code) => request(`/referral/${encodeURIComponent(code)}`),
  checkoutStatus: (sessionId) => request(`/checkout/${encodeURIComponent(sessionId)}`),
  runnerLogin: (email, code) => request("/runner/login", { method: "POST", body: JSON.stringify({ email, code }) }),
  runnerResendCode: (email) => request("/runner/code/resend", { method: "POST", body: JSON.stringify({ email }) }),
  runnerMe: () => request("/runner/me", {}, "runner"),
  runnerLogout: () => request("/runner/logout", { method: "POST" }, "runner"),
  runnerDelete: () => request("/runner/me", { method: "DELETE" }, "runner"),
  runnerProgram: () => request("/runner/program", {}, "runner"),
  gainage: () => request("/gainage"),
  gainageStabilite: () => request("/gainage/stabilite"),
  runnerTrack: (track) => request("/runner/program/track", { method: "PUT", body: JSON.stringify({ track }) }, "runner"),
  runnerWatchRead: (image_base64) => request("/runner/program/watch-read", { method: "POST", body: JSON.stringify({ image_base64 }) }, "runner"),
  runnerFeedback: (payload) => request("/runner/program/feedback", { method: "POST", body: JSON.stringify(payload) }, "runner"),
  runnerResume: () => request("/runner/program/resume", { method: "POST" }, "runner"),
  runnerAnalysis: (done) => request("/runner/program/analysis", { method: "POST", body: JSON.stringify({ done }) }, "runner"),
  runnerPortal: () => request("/runner/portal", { method: "POST" }, "runner"),
  runnerChat: () => request("/runner/chat", {}, "runner"),
  runnerAsk: (message) => request("/runner/chat", { method: "POST", body: JSON.stringify({ message }) }, "runner"),
  pushVapid: () => request("/runner/push/vapid"),
  pushSubscribe: (subscription) => request("/runner/push/subscribe", { method: "POST", body: JSON.stringify({ subscription }) }, "runner"),
  pushUnsubscribe: () => request("/runner/push/subscribe", { method: "DELETE" }, "runner"),
  pushTest: () => request("/runner/push/test", { method: "POST" }, "runner"),
  runnerActivity: (payload) => request("/runner/program/activity", { method: "POST", body: JSON.stringify(payload) }, "runner"),
  runnerDays: (days, reminders, dayMinutes, coachRenfo) => request("/runner/program/days", { method: "PUT", body: JSON.stringify({ days, reminders, day_minutes: dayMinutes || undefined, coach_renfo: !!coachRenfo }) }, "runner"),
  uploadGaitAnalysis: (file) => { const fd = new FormData(); fd.append("file", file); return request("/runner/program/gait-analysis", { method: "POST", body: fd }, "runner"); },
  deleteGaitAnalysis: () => request("/runner/program/gait-analysis", { method: "DELETE" }, "runner"),
  runnerTestimonial: (text) => request("/runner/testimonial", { method: "POST", body: JSON.stringify({ text }) }, "runner"),

  // Coach
  coachExportSummary: () => request("/coach/export/summary", {}, true),
  coachExportToken: () => request("/coach/export/token", { method: "POST" }, true),
  coachExportDownloadUrl: (token) => `${API}/coach/export/download/${token}`,
  coachRunnerExportToken: (id) => request(`/coach/runners/${id}/export/token`, { method: "POST" }, true),
  coachRunnerExportUrl: (id, token) => `${API}/coach/runners/${id}/export/download/${token}`,
  coachShoes: () => request("/coach/shoes", {}, true),
  coachSaveShoe: (shoe) => shoe.id
    ? request(`/coach/shoes/${shoe.id}`, { method: "PUT", body: JSON.stringify(shoe) }, true)
    : request("/coach/shoes", { method: "POST", body: JSON.stringify(shoe) }, true),
  coachDeleteShoe: (id) => request(`/coach/shoes/${id}`, { method: "DELETE" }, true),
  coachErrors: () => request("/coach/errors", {}, true),
  coachRules: () => request("/coach/rules", {}, true),
  coachSaveRules: (values) => request("/coach/rules", { method: "PUT", body: JSON.stringify({ values }) }, true),
  coachResetRules: (keys) => request("/coach/rules/reset", { method: "POST", body: JSON.stringify({ keys }) }, true),
  coachSaveError: (e) => request("/coach/errors", { method: "POST", body: JSON.stringify(e) }, true),
  coachDeleteError: (n) => request(`/coach/errors/${n}`, { method: "DELETE" }, true),
  coachTestError: (condition, profileId) => request("/coach/errors/test", { method: "POST", body: JSON.stringify({ condition, profile_id: profileId }) }, true),
  coachProfiles: () => request("/coach/profiles", {}, true),
  coachMode: () => request("/coach/mode", {}, true),
  coachSetMode: (auto) => request("/coach/mode", { method: "POST", body: JSON.stringify({ auto }) }, true),
  coachPendingSessions: () => request("/coach/sessions/pending", {}, true),
  coachEditSession: (programId, sessionId, text) => request(`/coach/sessions/${programId}/${sessionId}`, { method: "PUT", body: JSON.stringify(text) }, true),
  coachGuidance: () => request("/coach/guidance", {}, true),
  coachStripeHealth: () => request("/coach/stripe-health", {}, true),
  coachSetGuidance: (text) => request("/coach/guidance", { method: "POST", body: JSON.stringify({ text }) }, true),
  coachSendSession: (programId, sessionId, text) => request(`/coach/sessions/${programId}/${sessionId}/send`, { method: "POST", body: text ? JSON.stringify(text) : undefined }, true),
  coachTrialCodes: () => request("/coach/trial-codes", {}, true),
  coachAddTrialCode: (c) => request("/coach/trial-codes", { method: "POST", body: JSON.stringify(c) }, true),
  coachToggleTrialCode: (code) => request(`/coach/trial-codes/${encodeURIComponent(code)}/toggle`, { method: "POST" }, true),
  coachDeleteTrialCode: (code) => request(`/coach/trial-codes/${encodeURIComponent(code)}`, { method: "DELETE" }, true),
  coachAlerts: (all = false) => request(`/coach/alerts?all=${all}`, {}, true),
  coachAlertReply: (id, text, reuse) => request(`/coach/alerts/${id}/reply`, { method: "POST", body: JSON.stringify({ text, reuse }) }, true),
  coachAnswers: () => request("/coach/answers", {}, true),
  coachDeleteAnswer: (id) => request(`/coach/answers/${id}`, { method: "DELETE" }, true),
  coachResolveAlert: (id) => request(`/coach/alerts/${id}/resolve`, { method: "POST" }, true),
  coachRunners: () => request("/coach/runners", {}, true),
  coachRunner: (id) => request(`/coach/runners/${id}`, {}, true),
  coachMotorRecalc: () => request("/coach/motor-recalc", {}, true),
  coachMotorRecalcApply: (runner_ids) => request("/coach/motor-recalc/apply", { method: "POST", body: JSON.stringify({ runner_ids }) }, true),
  coachDeleteRunner: (id) => request(`/coach/runners/${id}`, { method: "DELETE" }, true),
  coachSetMotor: (id, motor) => request(`/coach/runners/${id}/motor`, { method: "POST", body: JSON.stringify({ motor }) }, true),
  coachSetLevel: (id, level, note = "", notify = true) => request(`/coach/runners/${id}/level`, { method: "POST", body: JSON.stringify({ level, note, notify }) }, true),
  coachMessage: (id, text) => request(`/coach/runners/${id}/message`, { method: "POST", body: JSON.stringify({ text }) }, true),
  coachValidateProfile: (id, text = "") => request(`/coach/runners/${id}/validate-profile`, { method: "POST", body: JSON.stringify({ text }) }, true),
  coachStats: () => request("/coach/stats", {}, true),
  coachTestimonials: () => request("/coach/testimonials", {}, true),
  coachAddTestimonial: (t) => request("/coach/testimonials", { method: "POST", body: JSON.stringify(t) }, true),
  coachModerateTestimonial: (id, action) => request(`/coach/testimonials/${id}/${action}`, { method: "POST" }, true),
  coachDeleteTestimonial: (id) => request(`/coach/testimonials/${id}`, { method: "DELETE" }, true),
  coachRunReminders: () => request("/coach/reminders/run", { method: "POST" }, true),
  coachRunNudges: () => request("/coach/nudges/run", { method: "POST" }, true),
  coachRunRecaps: () => request("/coach/recaps/run", { method: "POST" }, true),
  coachRunExpiry: () => request("/coach/expiry-reminders/run", { method: "POST" }, true),
  coachRunBilanNudges: () => request("/coach/bilan-nudges/run", { method: "POST" }, true),
  coachRunAnalysis: () => request("/coach/analysis-reminders/run", { method: "POST" }, true),
  coachStripe: () => request("/coach/stripe", {}, true),
  coachImportErrors: async (file) => {
    const form = new FormData();
    form.append("file", file);
    const t = getToken();
    const res = await fetch(`${API}/coach/errors/import`, { method: "POST", body: form, headers: t ? { Authorization: `Bearer ${t}` } : {} });
    if (!res.ok) throw new Error((await res.json().catch(() => ({})))?.detail || "Import impossible");
    return res.json();
  },
  coachImportShoes: async (file) => {
    const form = new FormData();
    form.append("file", file);
    const t = getToken();
    const res = await fetch(`${API}/coach/shoes/import`, { method: "POST", body: form, headers: t ? { Authorization: `Bearer ${t}` } : {} });
    if (!res.ok) throw new Error(`Erreur ${res.status}`);
    return res.json();
  },
};

/** Partage une image (Web Share API avec fichier, sinon téléchargement). */
export async function shareImage(url, filename, title) {
  const res = await fetch(url);
  const blob = await res.blob();
  const file = new File([blob], filename, { type: "image/png" });
  if (navigator.canShare && navigator.canShare({ files: [file] })) {
    await navigator.share({ files: [file], title });
    return "shared";
  }
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  a.click();
  return "downloaded";
}

export const openExternal = (url) => window.open(url, "_blank", "noopener");
